import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ObtenerActividadUsuarioDetalle = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Bitacora/DetalleBitacoraActividadUsuario",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { ObtenerActividadUsuarioDetalle };